var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.record.number_orders_driver.value > 0
    ? _c(
        "div",
        {
          staticClass: "lateness-cell",
          class: { "lateness-cell_disabled": !_vm.canEdit },
          on: {
            click: function ($event) {
              _vm.canEdit && (_vm.isShowOrdersModal = true)
            },
          },
        },
        [
          _c(
            "c-sidesheet",
            {
              staticClass: "lateness-cell-sidesheet",
              attrs: {
                title:
                  "Опоздания — " +
                  _vm.getParentColumnLabel(_vm.parentColumnId) +
                  " — " +
                  _vm.columnLabel,
                active: _vm.isShowOrdersModal,
              },
              on: { close: _vm.closeOrdersModal },
            },
            [
              _c("c-tabs", {
                ref: "tabs",
                staticClass: "orders-number-cell-sidesheet-tabs",
                attrs: { active: _vm.activeTab, items: _vm.tabs.items },
                on: { change: _vm.changeTab },
              }),
              _c("div", { staticClass: "position-relative h-100" }, [
                _c("div", {
                  staticClass: "orders-number-cell-sidesheet-table-shadow-top",
                  attrs: {
                    id: "orders-number-cell-sidesheet-table-shadow-top",
                  },
                }),
                _c(
                  "div",
                  {
                    staticClass: "orders-number-cell-sidesheet-table",
                    attrs: { id: "orders-number-cell-sidesheet-table" },
                    on: { scroll: _vm.setShadowsOnScroll },
                  },
                  [
                    _vm.isDataLoading
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "orders-number-cell-sidesheet-table-loader",
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.icon, spin: "" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.isDataLoading
                      ? _c("c-table-data-orders", {
                          ref: "table",
                          staticClass: "lateness-cell-sidesheet-table-table",
                          attrs: {
                            "empty-records-label": "Записи не найдены",
                            levels: 1,
                            "disabled-columns": _vm.tableData.disabledColumns,
                            "is-show-nested-orders-in-routes-tab": true,
                            data: _vm.tableData,
                            "active-tab": _vm.activeTab,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("div", {
                  staticClass:
                    "orders-number-cell-sidesheet-table-shadow-bottom",
                  attrs: {
                    id: "orders-number-cell-sidesheet-table-shadow-bottom",
                  },
                }),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "lateness-cell-value",
              class: {
                "lateness-cell-value-clickable":
                  !_vm.columnId.includes("inTotal"),
              },
            },
            [_vm._v(" " + _vm._s(_vm.record[_vm.columnId].value) + " ")]
          ),
        ],
        1
      )
    : _c("div", { staticClass: "lateness-cell-value" }, [
        _vm._v(" " + _vm._s(_vm.record[_vm.columnId].value) + " "),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }